module.exports = __webpack_public_path__ + "img/partner_01.756844a5.jpg";